// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d57fe93a","239":"aab4b8ab","455":"e996c877"}[chunkId] + ".chunk.js";
};